function viewInNewWindow(html) {
	const preview = window.open('about:blank');
	preview.document.write(html);
}

export default viewInNewWindow;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/view-in-new-window.js